/* amuee-reviews.js — behaviour for blocks/amuee-reviews.liquid.
   Was a 25 KB inline <script> in every HTML response; now a cached asset
   loaded deferred from the block. initAll() guards on readyState and re-runs
   on shopify:section:load, so timing is unchanged. */
(function () {
  var STAR = 'M329.208 126.666c-1.765-5.431-6.459-9.389-12.109-10.209l-95.822-13.922-42.854-86.837c-2.527-5.12-7.742-8.362-13.451-8.362s-10.925 3.242-13.451 8.362l-42.851 86.836-95.825 13.922c-5.65.821-10.345 4.779-12.109 10.209-1.764 5.431-.293 11.392 3.796 15.377l69.339 67.582-16.375 95.447c-.965 5.628 1.348 11.315 5.967 14.671 2.613 1.899 5.708 2.865 8.818 2.865 2.387 0 4.784-.569 6.979-1.723l85.711-45.059 85.71 45.059c2.208 1.161 4.626 1.714 7.021 1.723 8.275-.012 14.979-6.723 14.979-15 0-1.152-.13-2.275-.376-3.352l-16.233-94.629 69.339-67.583c4.089-3.985 5.56-9.946 3.796-15.377z';
  var CHECK = 'M20 6L9 17l-5-5';
  /* Per-row config. All four keys are optional:
       toggle   — dataset key whose "false" hides the whole row (see schema)
       order    — fixed chip order; values not listed fall to the end, data order
       hide     — chip values never offered as filters (reviews keep the tag on the card)
       defaults — chips pre-applied on load; the shopper can still clear or change them
     Range labels may be written with a plain hyphen here; matching is dash-insensitive. */
  var GROUPS_ALL = [
    { key: 'wrinkle', label: 'Wrinkle type', toggle: 'showWrinkleFilter' },
    { key: 'type', label: 'Scar type' },
    {
      key: 'age', label: 'Scar age',
      order: ['5+ Years', '5-10 Years', '1-5 Years', '6-12 Months', 'Under 6 Months']
    },
    { key: 'results', label: 'Time to results', hide: ['Under 1 Week', '1-2 Weeks'] }
  ];
  var SVGNS = 'http://www.w3.org/2000/svg';

  function svg(path, cls) {
    var s = document.createElementNS(SVGNS, 'svg');
    s.setAttribute('viewBox', cls === 'star' ? '0 0 330 330' : '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    if (cls === 'star') s.setAttribute('class', 'amrv-star' + (path === 'empty' ? ' amrv-star--empty' : ''));
    var p = document.createElementNS(SVGNS, 'path');
    p.setAttribute('d', cls === 'star' ? STAR : CHECK);
    s.appendChild(p);
    return s;
  }
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  /* A review's tag field may be an array ("Burn" + "Surgical") or a bare string.
     Everything downstream reads tags through here so both shapes work. */
  function vals(r, key) {
    var v = r[key];
    if (Array.isArray(v)) return v.filter(Boolean);
    v = (v || '').trim();
    return v ? [v] : [];
  }
  /* Data labels use an en dash ("1–5 Years"); the config above is easier to type with a
     plain hyphen. Compare through slug() so either spelling matches the same chip. */
  function slug(v) { return (v || '').replace(/[‐-―]/g, '-').trim().toLowerCase(); }
  function idxIn(list, v) {
    if (!list) return -1;
    var s = slug(v);
    for (var i = 0; i < list.length; i++) if (slug(list[i]) === s) return i;
    return -1;
  }
  function starsSpan(rating) {
    var w = el('span', 'amrv-stars'); w.setAttribute('role', 'img');
    w.setAttribute('aria-label', 'Rated ' + rating + ' out of 5 stars');
    for (var i = 1; i <= 5; i++) w.appendChild(svg(i > rating ? 'empty' : 'full', 'star'));
    return w;
  }

  function initRoot(root) {
    if (root.dataset.amrvInit === 'true') return;
    root.dataset.amrvInit = 'true';

    var grid = root.querySelector('[data-amrv-grid]');
    var filtersWrap = root.querySelector('[data-amrv-filters]');
    var clearBtn = root.querySelector('[data-amrv-clear]');
    var sortSelect = root.querySelector('[data-amrv-sort]');
    var loadMoreBtn = root.querySelector('[data-amrv-loadmore]');
    var remainingEl = root.querySelector('[data-amrv-remaining]');
    var statusEl = root.querySelector('[data-amrv-status]');
    var emptyEl = root.querySelector('[data-amrv-empty]');
    var emptyClearBtn = root.querySelector('[data-amrv-empty-clear]');
    var trustEl = root.querySelector('[data-amrv-trust]');
    var filterToggle = root.querySelector('[data-amrv-filter-toggle]');
    var filtersPanel = root.querySelector('[data-amrv-filters-panel]');
    var ftCount = root.querySelector('[data-amrv-ft-count]');

    var BATCH = parseInt(root.dataset.initialCount, 10) || 15;
    var MOBILE_INITIAL = parseInt(root.dataset.initialCountMobile, 10) || 4;
    var MOBILE_INCREMENT = parseInt(root.dataset.incrementMobile, 10) || 2;
    var GROUPS = GROUPS_ALL.filter(function (g) {
      return !g.toggle || root.dataset[g.toggle] !== 'false';
    }).map(function (g) {
      /* Copy before touching defaults: GROUPS_ALL is shared across every block on
         the page, and the pre-applied chip now comes from that block's settings,
         so two Amuee Reviews blocks can each start on a different filter. */
      var c = {}, k;
      for (k in g) if (Object.prototype.hasOwnProperty.call(g, k)) c[k] = g[k];
      var attr = 'default' + g.key.charAt(0).toUpperCase() + g.key.slice(1);
      var picked = (root.dataset[attr] || '').trim();
      if (picked) c.defaults = [picked]; else delete c.defaults;
      return c;
    });
    var mq = window.matchMedia('(max-width: 599px)');
    function isMobile() { return mq.matches; }
    var visibleCount = isMobile() ? MOBILE_INITIAL : BATCH;
    var activeFilters = {};
    GROUPS.forEach(function (g) { activeFilters[g.key] = []; });
    var cards = [];      // { data, node }
    var columns = [];
    var chipEls = [];    // every filter chip, for live count/disabled updates
    var loaded = false;

    /* Rating & count: live from data, or manual from the editor */
    var statsDynamic = root.dataset.statsDynamic !== 'false';
    var manualRating = (root.dataset.statsRating || '').trim();
    var manualCount = (root.dataset.statsCount || '').trim();
    var manualCountNum = parseInt(manualCount.replace(/[^0-9]/g, ''), 10);
    var footerTotal = (!statsDynamic && !isNaN(manualCountNum)) ? manualCountNum : null;
    var showRemaining = root.dataset.showRemaining !== 'false';

    /* ---- Lazy fetch when the section nears the viewport ---- */
    function load() {
      if (loaded) return; loaded = true;
      fetch(root.dataset.amrvSrc)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var audiencePins = ['Shefali Anand', 'Mrs.Beverage', 'Nubia'];
          data.forEach(function (review) {
            if (audiencePins.indexOf(review.name) !== -1) review.pinned = true;
          });
          return data;
        })
        .then(build)
        .catch(function () { statusEl.textContent = 'Reviews couldn’t be loaded.'; });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        if (ents[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '600px' });
      io.observe(root);
    } else { load(); }

    /* ---- Build a card node from a review object ---- */
    function buildCard(r, idx) {
      var card = el('article', 'amrv-card'); card.setAttribute('role', 'listitem');
      card.dataset.rating = r.rating || 0; card.dataset.date = r.date || '';
      card.dataset.helpful = r.helpful || 0; card.dataset.idx = idx;
      card.dataset.type = vals(r, 'type').join('|'); card.dataset.wrinkle = vals(r, 'wrinkle').join('|');
      card.dataset.age = vals(r, 'age').join('|'); card.dataset.results = vals(r, 'results').join('|');

      /* `"graphic": true` on a review keeps its text in the grid but withholds
         its photo from both the card and the lightbox — clinical wound images
         shouldn't load unasked. The review still counts as social proof. */
      if (r.photos && r.photos.length && !r.graphic) {
        var btn = el('button', 'amrv-photo-btn'); btn.type = 'button';
        btn.dataset.amrvPhotos = r.photos.map(function (u) { return u + '?width=1400'; }).join('||');
        btn.setAttribute('aria-label', 'View photo from ' + r.name);
        var img = document.createElement('img');
        img.src = r.photos[0] + '?width=600'; img.loading = 'lazy'; img.decoding = 'async';
        img.alt = 'Customer photo from ' + r.name;
        img.addEventListener('load', scheduleRelayout);
        btn.appendChild(img);
        if (r.photos.length > 1) { var c = el('span', 'amrv-photo-count'); c.textContent = '1/' + r.photos.length; btn.appendChild(c); }
        card.appendChild(btn);
      }
      var meta = el('div', 'amrv-card-meta');
      meta.appendChild(starsSpan(r.rating));
      if (r.verified) {
        var v = el('span', 'amrv-verified'); v.appendChild(svg('check', 'check'));
        v.appendChild(document.createTextNode('Verified')); meta.appendChild(v);
      }
      card.appendChild(meta);

      var p = el('p', 'amrv-text is-clamped'); p.dataset.amrvText = ''; p.textContent = r.text; card.appendChild(p);
      var rm = el('button', 'amrv-readmore'); rm.type = 'button'; rm.setAttribute('aria-expanded', 'false'); rm.textContent = 'Read more'; card.appendChild(rm);

      var tagSpecs = [['wrinkle', ''], ['type', ''], ['age', 'Scar: '], ['results', 'Results in ']];
      var tw = el('div', 'amrv-card-tags');
      tagSpecs.forEach(function (spec) {
        vals(r, spec[0]).forEach(function (v) {
          var t = el('span', 'amrv-tag');
          t.textContent = spec[1] + (spec[0] === 'results' ? v.toLowerCase() : v);
          tw.appendChild(t);
        });
      });
      if (tw.children.length) card.appendChild(tw);
      var f = el('footer', 'amrv-customer');
      var nm = el('p', 'amrv-name'); nm.textContent = r.name; f.appendChild(nm);
      if (r.location) { var lc = el('p', 'amrv-location'); lc.textContent = r.location; f.appendChild(lc); }
      card.appendChild(f);
      return card;
    }

    /* ---- Setup once data arrives ---- */
    function build(data) {
      statusEl.hidden = true;
      /* Nodes are built on first render, not up front — at 750+ reviews, eagerly
         constructing every card cost real main-thread time for cards nobody sees. */
      cards = data.map(function (r, i) { return { data: r, idx: i, node: null }; });

      /* Trust summary */
      if (cards.length) {
        var sum = data.reduce(function (a, r) { return a + (r.rating || 0); }, 0);
        var realAvg = Math.round(sum / cards.length * 10) / 10;
        var avgVal = statsDynamic ? realAvg : (parseFloat(manualRating) || realAvg);
        var avgText = statsDynamic ? String(realAvg) : (manualRating || String(realAvg));
        var countText = statsDynamic ? String(cards.length) : (manualCount || String(cards.length));
        var rd = Math.round(avgVal);
        var sw = trustEl.querySelector('[data-amrv-trust-stars]');
        for (var s = 1; s <= 5; s++) sw.appendChild(svg(s > rd ? 'empty' : 'full', 'star'));
        sw.setAttribute('aria-label', avgText + ' out of 5 stars');
        trustEl.querySelector('[data-amrv-trust-avg]').textContent = avgText;
        trustEl.querySelector('[data-amrv-trust-count]').textContent =
          'average from ' + countText + ' review' + (countText === '1' ? '' : 's');
        trustEl.hidden = false;
      }

      /* Tag counts + filter chips */
      var tagData = {};
      GROUPS.forEach(function (g) {
        var order = [], counts = {};
        data.forEach(function (r) {
          vals(r, g.key).forEach(function (v) {
            if (idxIn(g.hide, v) !== -1) return;   /* suppressed chip — tag stays on the card */
            if (!counts.hasOwnProperty(v)) { counts[v] = 0; order.push(v); }
            counts[v]++;
          });
        });
        if (g.order) order.sort(function (a, b) {
          var ia = idxIn(g.order, a), ib = idxIn(g.order, b);
          return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
        });
        tagData[g.key] = { order: order, counts: counts };
      });

      /* Pre-applied chips. Resolved against the data so a typo or a value that no
         longer exists simply doesn't apply, rather than filtering everything out. */
      GROUPS.forEach(function (g) {
        if (!g.defaults) return;
        g.defaults.forEach(function (d) {
          var i = idxIn(tagData[g.key].order, d);
          if (i === -1) return;
          var canonical = tagData[g.key].order[i];
          if (activeFilters[g.key].indexOf(canonical) === -1) activeFilters[g.key].push(canonical);
        });
      });
      GROUPS.forEach(function (g) {
        if (!tagData[g.key].order.length) return;
        var gp = el('div', 'amrv-filter-group'); gp.setAttribute('role', 'group');
        gp.setAttribute('aria-label', 'Filter by ' + g.label.toLowerCase());
        var lab = el('span', 'amrv-filter-label'); lab.textContent = g.label; gp.appendChild(lab);
        var cw = el('div', 'amrv-chips');
        tagData[g.key].order.forEach(function (tag) {
          var b = el('button', 'amrv-chip'); b.type = 'button';
          b.setAttribute('aria-pressed', activeFilters[g.key].indexOf(tag) !== -1 ? 'true' : 'false');
          b.dataset.filterGroup = g.key; b.dataset.filterValue = tag;
          b.appendChild(document.createTextNode(tag));
          /* Unfiltered total, kept so a chip that currently combines to nothing can
             still show its real review count instead of a bare 0. */
          b.dataset.baseCount = tagData[g.key].counts[tag];
          var cnt = el('span', 'amrv-chip-count'); cnt.textContent = tagData[g.key].counts[tag]; b.appendChild(cnt);
          cw.appendChild(b);
        });
        gp.appendChild(cw); filtersWrap.appendChild(gp);
      });
      if (filtersWrap.children.length) filterToggle.hidden = false;
      chipEls = Array.prototype.slice.call(filtersWrap.querySelectorAll('.amrv-chip'));

      /* Hide sort options lacking data */
      var hasDates = data.some(function (r) { return r.date; });
      var hasHelpful = data.some(function (r) { return (r.helpful || 0) > 0; });
      Array.prototype.slice.call(sortSelect.options).forEach(function (o) {
        var n = o.getAttribute('data-needs');
        if ((n === 'date' && !hasDates) || (n === 'helpful' && !hasHelpful)) o.remove();
      });

      apply();
      grid.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', scheduleRelayout);
      });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleRelayout);
    }

    /* ---- Masonry ---- */
    function getColCount() {
      var w = grid.getBoundingClientRect().width || window.innerWidth;
      /* Below 600px (the mobile breakpoint the stylesheet uses) it's always 2 columns,
         so phones get a 2-up grid instead of a single stack. 600px+ is unchanged. */
      if (w >= 1120) return 5; if (w >= 840) return 4; if (w >= 600) return 3; return 2;
    }
    function ensureColumns(n) {
      if (columns.length === n) return;
      columns.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); });
      columns = [];
      for (var i = 0; i < n; i++) { var c = el('div', 'amrv-col'); grid.appendChild(c); columns.push(c); }
    }
    function nodeFor(c) {
      if (!c.node) c.node = buildCard(c.data, c.idx);
      return c.node;
    }
    function layout(list) {
      var n = getColCount(); ensureColumns(n);
      var gap = parseInt(getComputedStyle(root).getPropertyValue('--amrv-gap'), 10) || 14;
      cards.forEach(function (c) { if (c.node) c.node.hidden = true; });
      var h = []; for (var i = 0; i < n; i++) h.push(0);
      list.forEach(function (c) {
        var node = nodeFor(c);
        node.hidden = false;
        var m = 0; for (var j = 1; j < n; j++) if (h[j] < h[m]) m = j;
        columns[m].appendChild(node); h[m] += node.offsetHeight + gap;
      });
    }

    /* AND across groups, OR within a group — the standard faceted-filter contract.
       "Burn or Keloid" AND "resolved in 3-4 weeks". Passing a group key in `skip`
       ignores that group, which is how chip counts are recomputed below. */
    function matchesExcept(c, skip) {
      for (var i = 0; i < GROUPS.length; i++) {
        var g = GROUPS[i].key;
        if (g === skip) continue;
        var sel = activeFilters[g];
        if (!sel.length) continue;
        var cv = vals(c.data, g), ok = false;
        for (var j = 0; j < cv.length; j++) if (sel.indexOf(cv[j]) !== -1) { ok = true; break; }
        if (!ok) return false;
      }
      return true;
    }
    function cardMatches(c) { return matchesExcept(c, null); }

    /* Each chip's count is "how many reviews you'd get if you added this one" —
       measured against the reviews already satisfying every OTHER group. A chip that
       would return nothing is disabled rather than left as a dead end. Selected chips
       stay enabled so a selection can always be undone. */
    function refreshChipCounts() {
      if (!chipEls.length) return;
      var counts = {};
      GROUPS.forEach(function (g) {
        var c1 = counts[g.key] = {};
        cards.forEach(function (c) {
          if (!matchesExcept(c, g.key)) return;
          vals(c.data, g.key).forEach(function (v) { c1[v] = (c1[v] || 0) + 1; });
        });
      });
      chipEls.forEach(function (b) {
        var g = b.dataset.filterGroup, v = b.dataset.filterValue;
        var n = (counts[g] && counts[g][v]) || 0;
        var selected = activeFilters[g].indexOf(v) !== -1;
        var base = parseInt(b.dataset.baseCount, 10) || 0;
        /* A chip that combines to nothing keeps its own review count on show and
           just fades — a row of zeros read as "this section has no reviews". */
        b.querySelector('.amrv-chip-count').textContent = n > 0 ? n : base;
        b.disabled = (n === 0 && !selected);
        b.title = n > 0 ? '' : base + ' review' + (base === 1 ? '' : 's') + ', none matching your current filters';
      });
    }
    function anyFilter() { return GROUPS.some(function (g) { return activeFilters[g.key].length; }); }
    function activeCount() { return GROUPS.reduce(function (n, g) { return n + activeFilters[g.key].length; }, 0); }

    function sorted() {
      var mode = sortSelect.value, arr = cards.slice();
      function dv(c) { var t = Date.parse(c.data.date || ''); return isNaN(t) ? null : t; }
      if (mode === 'newest' || mode === 'oldest') arr.sort(function (a, b) {
        var da = dv(a), db = dv(b);
        if (da === null && db === null) return 0; if (da === null) return 1; if (db === null) return -1;
        return mode === 'newest' ? db - da : da - db;
      });
      else if (mode === 'helpful') arr.sort(function (a, b) { return (b.data.helpful || 0) - (a.data.helpful || 0); });
      else if (mode === 'rating') arr.sort(function (a, b) { return (b.data.rating || 0) - (a.data.rating || 0); });
      else arr.sort(function (a, b) { return a.idx - b.idx; });

      /* `"pinned": true` reviews lead under EVERY sort mode, in their own file
         order — otherwise "Most helpful" or "Newest" would scatter them. They are
         still subject to the filters, so a pin that doesn't match a chip drops out
         rather than lying about the filtered result. */
      var pinned = arr.filter(function (c) { return c.data.pinned; });
      if (!pinned.length) return arr;
      pinned.sort(function (a, b) { return a.idx - b.idx; });
      return pinned.concat(arr.filter(function (c) { return !c.data.pinned; }));
    }

    function checkTruncation() {
      cards.forEach(function (c) {
        if (!c.node || c.node.hidden) return;
        var t = c.node.querySelector('[data-amrv-text]'), b = c.node.querySelector('.amrv-readmore');
        if (!t || !b || b.getAttribute('aria-expanded') === 'true') return;
        b.classList.toggle('is-visible', t.scrollHeight > t.clientHeight + 1);
      });
    }

    function apply() {
      var matched = sorted().filter(cardMatches);
      var list = matched.slice(0, visibleCount);
      layout(list);
      var shown = list.length, remaining = matched.length - shown;
      loadMoreBtn.hidden = matched.length === 0;
      loadMoreBtn.disabled = remaining <= 0;
      loadMoreBtn.textContent = remaining > 0 ? 'Show more reviews' : 'All reviews shown';
      var totalForFooter = (footerTotal && !anyFilter()) ? footerTotal : matched.length;
      remainingEl.textContent = (showRemaining && matched.length) ? 'Showing ' + shown + ' of ' + totalForFooter + ' reviews' : '';
      emptyEl.classList.toggle('is-visible', matched.length === 0);
      clearBtn.classList.toggle('is-visible', anyFilter());
      /* Say what clearing actually gets you. With a filter pre-applied on load, a
         bare "Clear filters" gave no hint that ~680 more reviews were behind it —
         the section read as if it only had 9. */
      clearBtn.textContent = 'Clear filters to see all reviews';
      ftCount.textContent = activeCount() ? activeCount() : '';
      refreshChipCounts();
      checkTruncation();
    }

    var rt = null;
    function scheduleRelayout() { clearTimeout(rt); rt = setTimeout(apply, 120); }
    window.addEventListener('resize', scheduleRelayout);

    /* ---- Delegated events on the grid ---- */
    grid.addEventListener('click', function (e) {
      var rm = e.target.closest('.amrv-readmore');
      if (rm) {
        var card = rm.closest('.amrv-card'), t = card.querySelector('[data-amrv-text]');
        var exp = rm.getAttribute('aria-expanded') === 'true';
        rm.setAttribute('aria-expanded', String(!exp));
        t.classList.toggle('is-clamped', exp);
        rm.textContent = exp ? 'Read more' : 'Read less';
        apply();
        return;
      }
      var pb = e.target.closest('.amrv-photo-btn');
      if (pb) { var ph = pb.dataset.amrvPhotos.split('||').filter(Boolean); if (ph.length) lbOpen(ph); }
    });

    filtersWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('.amrv-chip'); if (!chip) return;
      var g = chip.dataset.filterGroup, v = chip.dataset.filterValue;
      var pressed = chip.getAttribute('aria-pressed') === 'true';
      chip.setAttribute('aria-pressed', String(!pressed));
      if (pressed) activeFilters[g] = activeFilters[g].filter(function (x) { return x !== v; });
      else activeFilters[g].push(v);
      visibleCount = isMobile() ? MOBILE_INITIAL : BATCH; apply();
    });

    function clearAll() {
      GROUPS.forEach(function (g) { activeFilters[g.key] = []; });
      filtersWrap.querySelectorAll('.amrv-chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      visibleCount = isMobile() ? MOBILE_INITIAL : BATCH; apply();
    }
    clearBtn.addEventListener('click', clearAll);
    emptyClearBtn.addEventListener('click', clearAll);
    filterToggle.addEventListener('click', function () {
      var open = filtersPanel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', String(open));
    });
    sortSelect.addEventListener('change', function () { visibleCount = isMobile() ? MOBILE_INITIAL : BATCH; apply(); });
    loadMoreBtn.addEventListener('click', function () { visibleCount += (isMobile() ? MOBILE_INCREMENT : BATCH); apply(); });

    /* ---- Lightbox ---- */
    var lb = root.querySelector('[data-amrv-lightbox]'), lbImg = lb.querySelector('[data-amrv-lb-img]');
    var lbPrev = lb.querySelector('[data-amrv-lb-prev]'), lbNext = lb.querySelector('[data-amrv-lb-next]');
    var lbClose = lb.querySelector('[data-amrv-lb-close]'), lbCount = lb.querySelector('[data-amrv-lb-counter]');
    var lbPhotos = [], lbIdx = 0, lastFocus = null;
    function lbRender() {
      lbImg.removeAttribute('width'); lbImg.removeAttribute('height');
      lbImg.onload = function () { lbImg.setAttribute('width', lbImg.naturalWidth); lbImg.setAttribute('height', lbImg.naturalHeight); };
      lbImg.src = lbPhotos[lbIdx];
      var multi = lbPhotos.length > 1; lbPrev.hidden = !multi; lbNext.hidden = !multi;
      lbCount.textContent = multi ? (lbIdx + 1) + ' / ' + lbPhotos.length : '';
    }
    function lbOpen(ph) { lbPhotos = ph; lbIdx = 0; lastFocus = document.activeElement; lbRender(); lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; lbClose.focus(); }
    function lbCloseFn() { lb.classList.remove('is-open'); document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
    function lbStep(d) { lbIdx = (lbIdx + d + lbPhotos.length) % lbPhotos.length; lbRender(); }
    lbClose.addEventListener('click', lbCloseFn);
    lbPrev.addEventListener('click', function () { lbStep(-1); });
    lbNext.addEventListener('click', function () { lbStep(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lbCloseFn(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') lbCloseFn();
      if (e.key === 'ArrowLeft' && lbPhotos.length > 1) lbStep(-1);
      if (e.key === 'ArrowRight' && lbPhotos.length > 1) lbStep(1);
    });
    var tx = null;
    lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (tx === null || lbPhotos.length < 2) { tx = null; return; }
      var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) lbStep(dx < 0 ? 1 : -1); tx = null;
    }, { passive: true });
  }

  function initAll() { document.querySelectorAll('.amrv-root').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
